const _graphDefault = {
    renderingType: "geometricPrecision", //auto | optimizeSpeed | crispEdges | geometricPrecision | inherit
    height_mm: 241, // Размеры полотна (уже с учетом того, что требуетсся небольшой внутренний padding)
    width_mm: 181,
    paddingX_mm: 0.5, // Небольшие сдвиги для внутреннего отступа - нужны дл ятого, чтобы линии сетки прорисовались полностью с краев
    paddingY_mm: 0.5
};
const _gridDefault = {
    columns: 18,
    rows: 24,
    X_mm: 0,
    Y_mm: 0,
    subGridSectionQty: 10, // Количество подскекций маленькой сетки внутри 1 ячейки главной сетки

    cellWidth_mm: 10, // Размер рячейки главной сетки
    cellheight_mm: 10,
    majorLineWidth_mm: 0.3,
    minorLineWidth_mm: 0.1, //0.08,
    color: "#e0b9b3" //"#f5b2a6" //"#e0b9b3"
};
const _plotSettsDefault = {
    lineWidth: 0.8,
    channelHeight_mm: 40,
    channelWidth_mm: 180,
    ScaleY_mm_mV: 10,
    ScaleX_mm_sec: 40,
    meanderWidth_mm: 6,
    align: "", //"range", // range - центрировать по размаху сигнала
    need2Column: false,
    X_mm: 0,
    Y_mm: 0,
    labels: {
        fontSize_px: 13,
        color: "#808080"
    },
    channelNames: {
        X_mm: 2,
        Y_mm: 1,
        fontSize_px: 12,
        color: "#808080"
    },
    ticks: {
        height_mm: 3,
        width_mm: 0.25,
        color: "red"
    }
};

export const reprCmpxGraphSettings = {
    graphSetts: {
        ..._graphDefault,
        height_mm: 241,
        width_mm: 102
    },
    gridSetts: [
        {
            ..._gridDefault,
            columns: 5
        },
        {
            ..._gridDefault,
            columns: 5,
            X_mm: 51
        }
    ],
    plotSetts: {
        ..._plotSettsDefault,
        channelWidth_mm: 50,
        need2Column: true,
        X2_mm: 51
    }
};

export const rhythmGraphSettings = {
    graphSetts: {
        ..._graphDefault,
        height_mm: 21,
        width_mm: 181
    },
    gridSetts: [
        {
            ..._gridDefault,
            columns: 18,
            rows: 2
        }
    ],
    plotSetts: {
        ..._plotSettsDefault,
        channelHeight_mm: 20,
        channelWidth_mm: 180,
        ScaleY_mm_mV: 5,
        ScaleX_mm_sec: 10
    }
};

export const lead12GraphSettings = {
    graphSetts: {
        ..._graphDefault
    },
    gridSetts: [
        {
            ..._gridDefault
        }
    ],
    plotSetts: {
        ..._plotSettsDefault,
        channelHeight_mm: 20,
        channelWidth_mm: 180,
        ScaleY_mm_mV: 5,
        ScaleX_mm_sec: 25
    }
};
